module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.$route.params.title,
      "backFn": "土蠕e"
    },
    on: {
      "back": _vm.back
    }
  }, [_c('div', {
    staticClass: "head-r",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      }
    },
    slot: "right"
  }, [_vm._v("签到规则")])]), _vm._v(" "), _c('div', {
    staticClass: "sigin-top relative"
  }, [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": require("./bj.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    directives: [{
      name: "tapmode",
      rawName: "v-tapmode",
      value: ('active'),
      expression: "'active'"
    }],
    staticClass: "sigin-btn",
    on: {
      "click": _vm.signBtn
    }
  }, [_vm._v(_vm._s(_vm.signText))]), _vm._v(" "), (_vm.res.count) ? _c('span', [_vm._v("连续签到" + _vm._s(_vm.res.winecoin ? _vm.res.winecoin : 0) + "天")]) : _vm._e()])]), _vm._v(" "), _c('calendar', {
    attrs: {
      "nowDay": _vm.nowDay,
      "siginList": _vm.siginList,
      "getNum": _vm.getNum,
      "res": _vm.res,
      "signText": _vm.signText
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "sign"
  }, [_c('x-dialog', {
    staticClass: "tier",
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "rule-box"
  }, [_c('header', [_vm._v("签到规则"), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "text-l"
  }, [_c('p', [_vm._v("1.每天签到可得1酒币，连续签到笔前一天多1个酒币。")]), _vm._v(" "), _c('p', [_vm._v("2.连续签到10天，第11天开始活的酒币数将固定为10个。")]), _vm._v(" "), _c('p', [_vm._v("3.如中途间断，签到天数重新计算，系统重新开始累加。")]), _vm._v(" "), _c('p', [_vm._v("4.对不正当手段（包括但不限于作弊，扰乱系统，实施网络攻击等）获得酒币的用户，快买酒有权禁止其参与活动，并取消相应福利奖励。")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f1aba2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeSignIn/HomeSignIn.vue
// module id = 569
// module chunks = 0